<div class="representatives-list">
    <h2 translate>representatives</h2>
    <ul class="user-card-list">
        <li *ngFor="let item of representatives | orderBy: 'lastname'" class="user-card">
            <fa-icon [icon]="faUserCircle" size="4x" class="centered"></fa-icon>
            <p>{{ item.firstname }} {{ item.lastname }}</p>
        </li>
    </ul>
</div>
